import { useEffect, useState } from "react";
import ClientAdSettingsContent from "@components/Advertisement/components/ClientAdSettings/ClientAdSettingsContent";
import AdvertisementOverlay from "@features/advertisement/components/AdvertisementOverlay";
import { useUserInfo } from "@features/mySph/hooks/useUserInfo";

const ClientAdSettingsClientData = (): React.ReactElement => {
  const { isAuthenticated, userType } = useUserInfo();
  const [isClientDataInjected, setIsClientDataInjected] = useState(false);

  useEffect(() => {
    if (typeof window === "undefined") return;

    console.log("[ClientAdSettingsData] useEffect called"); // eslint-disable-line no-console

    window.bt_page_data = {
      ...window.bt_page_data,
      userInfo: isAuthenticated ? { usertype: userType } : null,
      adTargets: window.bt_page_data.adTargets,
    };

    setIsClientDataInjected(true);
  }, [isAuthenticated, userType]);

  if (!isClientDataInjected) {
    return (
      <AdvertisementOverlay className="h-100vh w-100vw fixed inset-0 left-0 top-0 z-[1000001] overflow-y-hidden bg-white" />
    );
  }

  return <ClientAdSettingsContent />;
};

export default ClientAdSettingsClientData;
